import Vue from "vue";
import Vuetify from "vuetify/lib";
import en from "vuetify/lib/locale/en";
import VSelect from "vuetify/lib/components/VSelect/VSelect";
import "@fortawesome/fontawesome-free/css/all.css";
import { applySelectA11yPatch } from "./selectA11y";

Vue.use(Vuetify);
applySelectA11yPatch(VSelect);

export default new Vuetify({
  lang: {
    locales: { "en-US": en },
    current: "en-US",
  },
  icons: {
    iconfont: "fa",
  },
  defaults: {
    global: {
      fontFamily: "Avenir",
    },
  },
  theme: {
    themes: {
      base: {
        primary: "#1976D2",
        secondary: "#424242",
        accent: "#97dffc",
        accentDark: "#0aaceb",
        error: "#D32F2F",
        errorLight: "#FDEDED",
        errorBackground: "#FDEDED",
        errorText: "#5F2120",
        info: "#1876D2",
        infoLight: "#e5f6fd",
        infoBackground: "#e5f6fd",
        infoText: "#014361",
        surface: "#cccccc",
        surfaceLight: "#f6f5f6",
        surfaceBackground: "#f6f5f6",
        surfaceText: "#212121",
        success: "#05820A",
        successLight: "#edf7ed",
        successBackground: "#edf7ed",
        successText: "#1E4620",
        warning: "#FFC107",
        warningLight: "#fff4e5",
        warningBackground: "#FFF4E5",
        warningText: "#663C00",
        brand: "#1E2549",
        brandPaleBlue: "#EEF8FC",
        grey: "#BABABA",
        lightGrey: "#EEEEEE",
        mediumGrey: "#666666",
        darkGrey: "#666666",
        brandGreen: "#9FCD63",
        brandPaleGreen: "#F4FFEB",
        brandLightGreen: "#d3f2b5",
        brandDarkGreen: "#379F0A",
        brandYellow: "#FFDA5D",
        brandPink: "#FFA2FF",
        brandLightCyan: "#E4F2F5",
        brandCyan: "#09ACEC",
        brandDarkCyan: "#00B0F3",
        brandPurple: "#858AE3",
        brandOrange: "#FFAB1F",
        brandPrimary: "#077DAF",
        brandPrimaryDark: "#05628A",
        brandCyanLight: "#E6F5FD",
        brandSecondary: "#50C0C0",
        systemPrimary: "#002A4E",
        systemWalletGreen: "#379F0A",
      },
      light: {
        primary: "#1976D2",
        secondary: "#424242",
        accent: "#97dffc",
        accentDark: "#0aaceb",
        error: "#D32F2F",
        errorLight: "#FDEDED",
        errorBackground: "#FDEDED",
        errorText: "#5F2120",
        info: "#1876D2",
        infoLight: "#e5f6fd",
        infoBackground: "#e5f6fd",
        infoText: "#014361",
        surface: "#cccccc",
        surfaceLight: "#f6f5f6",
        surfaceBackground: "#f6f5f6",
        surfaceText: "#212121",
        success: "#05820A",
        successLight: "#edf7ed",
        successBackground: "#edf7ed",
        successText: "#1E4620",
        warning: "#FFC107",
        warningLight: "#fff4e5",
        warningBackground: "#FFF4E5",
        warningText: "#663C00",
        brand: "#1E2549",
        brandPaleBlue: "#EEF8FC",
        grey: "#BABABA",
        lightGrey: "#EEEEEE",
        mediumGrey: "#666666",
        darkGrey: "#666666",
        brandGreen: "#9FCD63",
        brandPaleGreen: "#F4FFEB",
        brandLightGreen: "#d3f2b5",
        brandDarkGreen: "#379F0A",
        brandYellow: "#FFDA5D",
        brandPink: "#FFA2FF",
        brandLightCyan: "#E4F2F5",
        brandCyan: "#09ACEC",
        brandDarkCyan: "#00B0F3",
        brandPurple: "#858AE3",
        brandOrange: "#FFAB1F",
        brandPrimary: "#077DAF",
        brandPrimaryDark: "#05628A",
        brandCyanLight: "#E6F5FD",
        brandSecondary: "#50C0C0",
        systemPrimary: "#002A4E",
        systemWalletGreen: "#379F0A",
      },
    },
    options: {
      customProperties: true,
    },
  },
});
